import React from 'react';

import { BubbleSetIconVariant } from '@repo/ui/Icon';
import { BubbleSetIcon } from '@repo/ui/Icon';
import { getServiceName } from '@repo/utils';
import styled from 'styled-components';

type EmptyViewProps = {
  text: string;
};
export default function EmptyView({ text }: EmptyViewProps) {
  const serviceName = getServiceName();
  return (
    <SEmptyView>
      {serviceName === 'bubblechat' && <BubbleSetIcon variant={BubbleSetIconVariant.SAD} size={48} color="#ADB0B8" />}
      <p className="text">{text}</p>
    </SEmptyView>
  );
}

const SEmptyView = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .text {
    color: ${({ theme }) => theme.color.icon.icon_1};
    ${({ theme }) => theme.font.body2_r};
    text-align: center;
  }
`;
